import { useSoundEffect } from '../../hooks/useSoundEffect';
import WRITING_SOUND from '../../assets/audio/writing.wav';
import OPEN_BOOK_SOUND from '../../assets/audio/open_book.wav';

import './diary.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DIARY_TRANSFORMATION } from './diary_text_transformation';

interface DiaryTextProps {
    isIntro: boolean;
}

function DiaryText(props: DiaryTextProps) {
    const { isIntro } = props;
    const [displayedText, setDisplayedText] = useState(DIARY_TRANSFORMATION[0]);
    const indexRef = useRef(0);

    const updateDiary = useCallback(() => {
        if (indexRef.current >= DIARY_TRANSFORMATION.length) {
            return;
        }
        setDisplayedText(DIARY_TRANSFORMATION[indexRef.current]);
        indexRef.current += 1;
        setTimeout(() => {
            updateDiary();
        }, 200);
    }, []);

    useEffect(() => {
        if (!isIntro) {
            updateDiary();
        }
    }, [isIntro, updateDiary]);

    // Some of the messiest code I've ever written. Sorry to the next person who reads this.
    return (
        <>
            {displayedText.map((line) => {
                return (
                    <div key={line}>
                        {line.split('\n').map((subline) => {
                            const textDecorationSections = subline.split('--');
                            const hasDecoration =
                                textDecorationSections.length > 1;
                            const style: React.CSSProperties = {};
                            if (subline.includes('  ')) {
                                style.whiteSpace = 'pre';
                            }
                            return (
                                <div key={subline} style={style}>
                                    {hasDecoration ? (
                                        <>
                                            {textDecorationSections[0]}
                                            <s
                                                style={{
                                                    textDecorationStyle:
                                                        'double',
                                                }}
                                            >
                                                {textDecorationSections[1]}
                                            </s>
                                            {textDecorationSections[2]}
                                        </>
                                    ) : (
                                        subline
                                    )}
                                    <br />
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
}

interface DiaryProps {
    isIntro: boolean;
}

function Diary(props: DiaryProps) {
    const { isIntro } = props;
    const {
        play: writingSound,
        loop: loopWritingSound,
        endLoop: endLoopWritingSound,
    } = useSoundEffect(WRITING_SOUND);
    const { play: openBookSound } = useSoundEffect(OPEN_BOOK_SOUND);

    useEffect(() => {
        let openBookHandle: ReturnType<typeof setTimeout>;
        if (isIntro) {
            openBookHandle = setTimeout(() => {
                openBookSound();
            }, 700);
        }
        const writingSoundHandle = setTimeout(
            () => {
                loopWritingSound();
            },
            isIntro ? 1500 : 1000
        );
        if (!isIntro) {
            setTimeout(() => {
                endLoopWritingSound();
            }, 13200);
        }
        return () => {
            clearTimeout(writingSoundHandle);
            if (openBookHandle) {
                clearTimeout(openBookHandle);
            }
            endLoopWritingSound();
        };
    }, [
        endLoopWritingSound,
        isIntro,
        loopWritingSound,
        openBookSound,
        writingSound,
    ]);

    return (
        <div className="diary">
            {isIntro ? (
                <div className="turn-page">
                    <div className="diary-cover diary-cover-front">
                        <div className="diary-title">My Diary</div>
                        <div className="diary-crease" />
                    </div>
                    <div className="diary-cover diary-back-cover start-closed" />
                </div>
            ) : (
                <div className="diary-cover diary-back-cover" />
            )}
            <div className="diary-pages">
                <div className="diary-content">
                    <DiaryText isIntro={isIntro} />
                </div>
            </div>
        </div>
    );
}

export default Diary;
